import {
  ComponentParams,
  ComponentRendering,
  Field,
  GetServerSideComponentProps,
  ImageField,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { ChildrenAnimalMotif } from '@ahc-digital/component-library';
import { CreatechildrenAnimalMotif } from './C46ChildrensAnimalMotif.service';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';

export interface C46ChildrensAnimalMotifProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams;
  fields?: C46ChildrensAnimalMotifFields;
  randomAnimalIndex?: number;
}

export interface C46ChildrensAnimalMotifFields {
  FirstAnimalimage?: ImageField;
  FirstAnimalQuote?: Field<string>;
  SecondAnimalImage?: ImageField;
  SecondAnimalQuote?: Field<string>;
  ThirdAnimalImage?: ImageField;
  ThirdAnimalQuote?: Field<string>;
  FourthAnimalImage?: ImageField;
  FourthAnimalQuote?: Field<string>;
  FifthAnimalImage?: ImageField;
  FifthAnimalQuote?: Field<string>;
  StaticMobileImage?: ImageField;
}

export const Default = (props?: C46ChildrensAnimalMotifProps): JSX.Element => {
  if (!props?.rendering?.dataSource) {
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  }

  return (
    <ChildrenAnimalMotif
      {...CreatechildrenAnimalMotif(props)}
      randomAnimalIndex={props.randomAnimalIndex}
    />
  );
};

export const getServerSideProps: GetServerSideComponentProps = async () => {
  const randomAnimalIndex = Math.floor(Math.random() * 5);
  return { randomAnimalIndex };
};
